import { Observable, of } from 'rxjs';
import * as i0 from "@angular/core";
const clipboardAPI = 'clipboard';
export class ClipboardService {
    constructor() { }
    getClipboardAPISupport() {
        return clipboardAPI in navigator;
    }
    getClipboardAPI() {
        return navigator[clipboardAPI];
    }
    copyToClipboard(val) {
        if (this.getClipboardAPISupport()) {
            const clipboard = this.getClipboardAPI();
            return new Observable((observer) => {
                clipboard.writeText(val)
                    .then(() => {
                    observer.next(true);
                    observer.complete();
                })
                    .catch((e) => {
                    observer.next(false);
                    observer.complete();
                });
            });
        }
        else { // async copy unsupported
            return of(false);
        }
    }
    copyInputFieldValue(input) {
        input.select();
        let copied = false;
        try {
            copied = document.execCommand('copy');
        }
        catch (err) {
            copied = false;
        }
        return copied;
    }
}
ClipboardService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ClipboardService_Factory() { return new ClipboardService(); }, token: ClipboardService, providedIn: "root" });
